import { actionCreator, checkHttpStatus, 
  DELETE_APPLIED_LEAVE,
  DELETE_STAFF_API,
  DELETE_USER_TIME_SHEET_DETAILS, GET_APPLIED_STAFF_LEAVE, GET_APPLY_LEAVE_BY_ID,
  GET_AVAILABILITY_TEMPLATE, GET_DOCTOR_DETAILS_FROM_API,
  GET_MASTERCUSTOMLABELS,
  GET_MASTERDATABYNAME,  
  GET_OFFICE_HOURS_API,
  GET_STAFF_AND_PATIENT_BYLOCATION,
  GET_STAFF_PROFILE_DETAILS_API,
  GET_STAFF_TIME_SHEET_DATA,
  GET_STAFF_TIME_SHEET_DATA_TABLE_VIEW,
  GET_STAFFDETAILS_API,
  GET_STAFFS_LIST_API,
  GET_USER_TIME_SHEET_BY_ID,
  jsonApiHeader,
  POST_AVAILABILITY_TEMPLATE_API,
  POST_CUSTOM_VALUES_API,
  POST_STAFF_LEAVE,
  SAVE_STAFFDETAILS_API,
  SAVE_USER_TIME_SHEET_DETAILS,
  showErrorMessage,
  showSuccessMessage, showWarningMessage, STAFF_LOCK_ACTIVATION, STAFF_STATUS_ACTIVATION, SUBMIT_TIMESHEET_STATUS, UPDATE_LEAVE_STATUS, UPDATE_STAFF_TIME_SHEET, userActionTypes, GET_STAFF_PAYROLL_RATE_API, POST_STAFF_PAYROLL_RATE_API, GET_STAFF_LOCATIONS_API, GET_AVAILABILITY_TEMPLATE_WITH_LOCATION, POST_AVAILABILITY_TEMPLATE_WITH_LOCATION_API, GET_PATIENT_LIST, 
  POST_STAFF_INTERNAL_NOTES_API, GET_STAFF_INTERNAL_NOTES_API, DELETE_STAFF_INTERNAL_NOTES_API, GET_STAFFBYTAGS_API, POST_STAFF_TRAINING_TITLE_HOURS_API, GET_STAFF_TRAINING_TITLE_HOURS_API, GET_USERROLES_API, GET_APPOINTMENTTYPELIST, STAFF_SCHEDULER_LOCK, GET_CLIENTBYTAGS_API,POST_RESETUSEREMAIL,POST_CHECKEMAILCHANGEVALIDATION} from './../constants/ApiConstants';
import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck,createSearchUrlForCustomAPI } from '../../../actions/utilAction';

export const getMasterData = (masterDataList) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_masterdata.REQUEST));
    if (masterDataList === '' || masterDataList === undefined) {
      masterDataList = 'masterLocation,addresstype,masterCountry,masterEthnicity,maritalStatus,masterPreferredLanguage,masterRace,masterState,PatientStatus,Suffix,masterRelationship,masterprovider,masterProgram,masterService,phonetype,masterInsuranceCompany,masterReferral,insurancePlanType,mastericd,socialhistory,travelhistory,masterstaff,masterGender,masterPatientCommPreferences,MASTERVFC,MASTERIMMUNIZATION,MASTERMANUFACTURE,MASTERADMINISTRATIONSITE,mastercustomlabels,MASTERROUTEOFADMINISTRATION,masterCustomLabelStaff,MASTERIMMUNITYSTATUS,MASTERREJECTIONREASON,MASTERSTAFF,labtesttype,masterlonic,masterlabs,timetype,frequencytype,frequencydurationtype,MASTERALLERGIES,MASTERREACTION,MASTERSERVICECODE,authorizedprocedure,MASTERPATIENTLOCATION,appointmentType,MASTERTAGS,MASTERROLES,staffavailability,LEAVETYPE,LEAVEREASON,appointmenttype,TIMESHEETSTATUS';
    }
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': masterDataList }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(userActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
      // errorHandler(error);
      });
  };
};

// export const getUserMasterTags = (searchObj) => {
//   // let query_params = `?filter[TypeKey]=${searchObj.TypeKey}`;
//   let query_params = createSearchUrlWithoutPageNumberAndSize(searchObj);
//   return (dispatch, getState) => {
//     dispatch(actionCreator(userActionTypes.get_user_master_tags.REQUEST));
//     fetch(`${GET_MASTERTAGS}${query_params}`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(userActionTypes.get_user_master_tags.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('error getUserMasterTags...', error);
//       });
//   };
// };

export const showUsersSubMenus = (showStatus) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.user_menu_show_status.SUCCESS, showStatus));
  };
};

export const getStaffProfileDetails = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_staffProfileDetails.REQUEST));
    fetch(`${GET_STAFF_PROFILE_DETAILS_API}/${staffId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204 && response.statusCode < 300) {
          dispatch(actionCreator(userActionTypes.get_staffProfileDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_staffProfileDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error getStaffProfileDetails...', error);
      });
  };
};

export const getStaffDetailsById = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_staffDetailsById.REQUEST));
    fetch(`${GET_STAFFDETAILS_API}?id=${staffId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204 && response.statusCode < 300) {
          dispatch(actionCreator(userActionTypes.get_staffDetailsById.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_staffDetailsById.FAILURE, null));
        }
      })
      .catch(function(error) {
        console.log('error getStaffDetailsById...', error);
      });
  };
};

export const SaveUserDetails = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.save_staffDetails.REQUEST));
    fetch(`${SAVE_STAFFDETAILS_API}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {        
        if (response.statusCode >= 200 && response.statusCode < 204 && response.statusCode < 300) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.save_staffDetails.SUCCESS, response));
        } else if(response.statusCode === 500){
          Alert.closeAll();
          showWarningMessage(response.message);
          dispatch(actionCreator(userActionTypes.save_staffDetails.SUCCESS, null));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.save_staffDetails.FAILURE));
        }
      })
      .catch(function(error) {
        dispatch(actionCreator(userActionTypes.save_staffDetails.FAILURE));
        console.log('error----', error);
      });
  };
};

/*
Generic method for extracting data from included array
created by: Lovepreet singh

*/
export function extractDataFromObject(type, myArray, id) {
  if (myArray !== undefined) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].type === type && parseInt(myArray[i].id, 10) === parseInt(id, 10)) {
        return myArray[i].attributes;
      }
    }
  }
}


export function extractLocationData(type, myArray, PatientID, locationArr) {
  let returnArr = [];
  let locationData = [];
  let locationId = '';
  let locationIdsArr = [];
  function dataFunction(locationId) {
    if (!locationIdsArr.includes(locationId) && locationId !== 0) {
      locationData = locationArr.find((i) => i.id === locationId);
      returnArr.push(locationData);
      locationIdsArr.push(locationId);
    }
    return { returnArr, locationIdsArr };
  }
  if (myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].type === type && parseInt(myArray[i].attributes.PatientID, 10) === parseInt(PatientID, 10)) {
        locationId = myArray[i].attributes.PatientLocationID;
        dataFunction(locationId);
      }
    }
  } else {
    returnArr.push({ id: 0, value: 'No location found' });
  }
  return returnArr;
}

export const getStaffsList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_staffsList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);

    fetch(`${GET_STAFFS_LIST_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_staffsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_staffsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get_staffsList...', error);
      });

  };
};

export const deleteStaffDetails = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.delete_staffDetails.REQUEST));
    fetch(`${DELETE_STAFF_API}?id=${staffId}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        Alert.closeAll();
        dispatch(actionCreator(userActionTypes.delete_staffDetails.SUCCESS, response));
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
      })
      .catch(function(error) {
        console.log('error deleteStaffDetails...', error);
      });
  };
};

export const getMasterCustomLabels = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_masterCustomLabels.REQUEST));
    fetch(`${GET_MASTERCUSTOMLABELS}?staffId=${staffId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_masterCustomLabels.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_masterCustomLabels.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_masterCustomLabels', error);
      });
  };
};

// export const getCustomAction = (searchObj) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(userActionTypes.get_staff_custom.REQUEST));
//     let query_params = createSearchUrlWithoutPageNumberAndSize(searchObj);
//     fetch(`${STAFF_CUSTOM_API}${query_params}`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(userActionTypes.get_staff_custom.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('error getCustomAction....', error);
//       });
//   };
// };

export const saveCustomLabelValues = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.post_staffCustomValues.REQUEST));
    fetch(`${POST_CUSTOM_VALUES_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(postData),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staffCustomValues.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staffCustomValues.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_staffCustomValues', error);
      });
  };
};

export const getAvailabilityTemplateByStaffID_withLocation = (staffId, locationId) => {
  return (dispatch, getState) => {

    dispatch(actionCreator(userActionTypes.get_availability_template_by_id.REQUEST));
    let url = `${GET_AVAILABILITY_TEMPLATE_WITH_LOCATION}?staffId=${staffId}&locationId=${locationId}&isLeaveNeeded=${false}`;
    fetch(url, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_availability_template_by_id.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_availability_template_by_id.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error getAvailabilityTemplateByStaffID_withLocation', error);
      });
  };
};

export const saveAvailabilityTemplate_withLocation = (formProps) => {
  let postData = JSON.stringify(formProps);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.save_availibility_template.REQUEST));
    fetch(`${POST_AVAILABILITY_TEMPLATE_WITH_LOCATION_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.save_availibility_template.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.save_availibility_template.FAILURE));
        }
      })
      .catch(function(error) {
        console.log('error saveAvailabilityTemplate_withLocation', error);
        dispatch(actionCreator(userActionTypes.save_availibility_template.FAILURE));
      });
  };
};

export const getAvailabilityTemplateByStaffID = (staffId) => {
  return (dispatch, getState) => {

    dispatch(actionCreator(userActionTypes.get_availability_template_by_id.REQUEST));
    let url = `${GET_AVAILABILITY_TEMPLATE}/${staffId}/false`;
    fetch(url, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_availability_template_by_id.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_availability_template_by_id.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_availability_template_by_id', error);
      });
  };
};
export const saveAvailabilityTemplate = (formProps) => {
  let postData = JSON.stringify(formProps);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.save_availibility_template.REQUEST));
    fetch(`${POST_AVAILABILITY_TEMPLATE_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.save_availibility_template.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.save_availibility_template.FAILURE));
        }
      })

      .catch(function(error) {
        console.log('error----', error);
        dispatch(actionCreator(userActionTypes.save_availibility_template.FAILURE));
      });
  };
};
export const UpdateStaffActiveStatus = (staffID, IsActivate, locParam) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.patch_staff_active_status.REQUEST));
    fetch(`${STAFF_STATUS_ACTIVATION}?staffId=${staffID}&isActive=${IsActivate}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.patch_staff_active_status.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.patch_staff_active_status.SUCCESS, {}));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(userActionTypes.patch_staff_active_status.SUCCESS, {}));
      });
  };

};

export const UpdateStaffScheduleLock = (staffId, schedulerLockedDate) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.patch_staff_scheduler_lock.REQUEST));
    fetch(`${STAFF_SCHEDULER_LOCK}?staffId=${staffId}&schedulerLockedDate=${schedulerLockedDate}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.patch_staff_scheduler_lock.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.patch_staff_scheduler_lock.SUCCESS, {}));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(userActionTypes.patch_staff_scheduler_lock.SUCCESS, {}));
      });
  };

};

export const UpdateStaffLockStatus = (staffID, IsBlock, locParam) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.patch_staff_lock_status.REQUEST));
    // console.log('url', `${STAFF_LOCK_ACTIVATION}/${staffID}/${IsBlock}`);
    fetch(`${STAFF_LOCK_ACTIVATION}/${staffID}/${IsBlock}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(userActionTypes.patch_staff_lock_status.SUCCESS, response));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(userActionTypes.patch_staff_lock_status.SUCCESS, {}));
          }
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(userActionTypes.patch_staff_lock_status.SUCCESS, {}));
      });
  };

};

export const getOfficeHours = (locationIds) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_office_hours.REQUEST));
    fetch(`${GET_OFFICE_HOURS_API}?locationIds=${locationIds}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 300) {
          dispatch(actionCreator(userActionTypes.get_office_hours.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_office_hours.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error getOfficeHours...', error);
      });
  };
};

export const getStaffLocationsById = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_staffLocations.REQUEST));
    fetch(`${GET_STAFF_LOCATIONS_API}?Id=${staffId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 300) {
          dispatch(actionCreator(userActionTypes.get_staffLocations.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_staffLocations.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_staffLocations...', error);
      });
  };
};

export const getAppliedLeaveList = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(userActionTypes.get_applied_leave_list.REQUEST));
    fetch(`${GET_APPLIED_STAFF_LEAVE}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        if (response) {
          dispatch(actionCreator(userActionTypes.get_applied_leave_list.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};

export const getAppliedLeaveListbyId = (staffLeaveId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_applied_leave_by_id.REQUEST));

    fetch(`${GET_APPLY_LEAVE_BY_ID}?StaffLeaveId=${staffLeaveId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(userActionTypes.get_applied_leave_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};

export const saveAppliedLeave = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.post_staff_leave.REQUEST));
    fetch(`${POST_STAFF_LEAVE}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staff_leave.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staff_leave.FAILURE));
        }
      })

      .catch(function(error) {
        console.log('error----', error);
        dispatch(actionCreator(userActionTypes.save_availibility_template.FAILURE));
      });
  };
};
export const deleteAppliedLeave = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.delete_applied_leave.REQUEST));

    fetch(`${DELETE_APPLIED_LEAVE}?StaffLeaveId=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.delete_applied_leave.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const updateLeaveStatus = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.update_leave_status.REQUEST));
    fetch(`${UPDATE_LEAVE_STATUS}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.update_leave_status.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staff_leave.FAILURE));
        }
      })

      .catch(function(error) {
        console.log('error----', error);
        dispatch(actionCreator(userActionTypes.save_availibility_template.FAILURE));
      });
  };
};
export const getStaffTimeSheetData = (staffId, weekValue) => {
  return (dispatch, getState) => {
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(userActionTypes.get_staff_time_sheet.REQUEST));
    fetch(`${GET_STAFF_TIME_SHEET_DATA}?staffIds=${staffId}&weekValue=${weekValue}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(userActionTypes.get_staff_time_sheet.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};

export const updateStaffTimeSheet = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.update_staff_time_sheet.REQUEST));
    fetch(`${UPDATE_STAFF_TIME_SHEET}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.update_staff_time_sheet.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.update_staff_time_sheet.FAILURE));
        }
      })
      .catch(function(error) {
        console.log('error----', error);
      });
  };
};
export const getStaffTimeSheetDataTableView = (staffId, weekValue) => {
  return (dispatch, getState) => {
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(userActionTypes.get_staff_time_sheet_table_view.REQUEST));
    fetch(`${GET_STAFF_TIME_SHEET_DATA_TABLE_VIEW}?staffIds=${staffId}&weekValue=${weekValue}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(userActionTypes.get_staff_time_sheet_table_view.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const getStaffsAndPatientsByLocation = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=${searchObj.permissionKey}&isActiveCheckRequired=${searchObj.isActiveCheckRequired}`;
  // console.log(`${GET_STAFF_AND_PATIENT_BYLOCATION}?locationId=${locationId}`);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_staff_and_patient_bylocation.REQUEST));

    fetch(`${GET_STAFF_AND_PATIENT_BYLOCATION}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
      // console.log('response: ', response);
        dispatch(actionCreator(userActionTypes.get_staff_and_patient_bylocation.SUCCESS, response));

      })
      .catch(function(error) {
        console.log('get staff and client by location error', error);
      });
  };
};
export const SaveUserTimeSheetDetails = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.save_user_time_sheet_details.REQUEST));
    fetch(`${SAVE_USER_TIME_SHEET_DETAILS}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(userActionTypes.save_user_time_sheet_details.SUCCESS, response));
        if (response.statusCode >= 200 && response.statusCode < 204 && response.statusCode < 300) {
          Alert.closeAll();
          showSuccessMessage(response.message);
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
        }
      })
      .catch(function(error) {
        dispatch(actionCreator(userActionTypes.save_user_time_sheet_details.FAILURE));
        console.log('error----', error);
      });
  };
};
export const getUserTimeSheetbyId = (timeSheetId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_user_time_sheet_by_id.REQUEST));

    fetch(`${GET_USER_TIME_SHEET_BY_ID}/${timeSheetId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(userActionTypes.get_user_time_sheet_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const deleteUserTimeSheetDetails = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.delete_user_time_sheet.REQUEST));

    fetch(`${DELETE_USER_TIME_SHEET_DETAILS}?Id=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.delete_user_time_sheet.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};

export const submitTimeSheetStatus = (ids) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.submit_timesheet_status.REQUEST));
    fetch(`${SUBMIT_TIMESHEET_STATUS}?Ids=${ids}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.submit_timesheet_status.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.submit_timesheet_status.FAILURE));
        }
      })

      .catch(function(error) {
        console.log('error----', error);
      });
  };
};

export const getStaffPayRatesforActivities = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_staffPayrollRates.REQUEST));
    fetch(`${GET_STAFF_PAYROLL_RATE_API}?staffId=${staffId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_staffPayrollRates.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_staffPayrollRates.SUCCESS, null));
        }
      })
      .catch((e) => {
        console.log('error get_staffPayrollRates..', e);
      });
  };
};

export const saveStaffPayRatesforActivities = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.post_staffPayrollRates.REQUEST));
    fetch(`${POST_STAFF_PAYROLL_RATE_API}`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staffPayrollRates.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staffPayrollRates.SUCCESS, null));
        }
      })
      .catch((e) => {
        console.log('error post_staffPayrollRates..', e);
      });
  };
};


export const asyncValidateAction = (npiNumber, resolve, reject, access_token) => {
  fetch(`${GET_DOCTOR_DETAILS_FROM_API}?npiNumber=${npiNumber}`, {
    method: 'get',
    headers: jsonApiHeader(access_token, 'application/json'),
  })
    .then(checkHttpStatus)
    .then(function(response) {
      // console.log('response', response);
      if (!(response.data.result_count > 0)) {
        reject({ npiNumber: 'NPI does not exist' });
      } else {
        resolve();
      }
    })
    .catch(function(error) {
      console.log('error: ', error);
    });
  // };
};

export const getPatientList = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=''&isActiveCheckRequired=${searchObj.isActiveCheckRequired}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_patient_list.REQUEST));
    fetch(`${GET_PATIENT_LIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        dispatch(actionCreator(userActionTypes.get_patient_list.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};


// save Update Staff Internal Notes
export const saveStaffInternalNote = (formData, staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.Post_Staff_Internal_Notes.REQUEST));
    let apiURL = `${POST_STAFF_INTERNAL_NOTES_API}`;
    fetch(`${apiURL}`, {
      method: 'POST',      
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formData)
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          dispatch(actionCreator(userActionTypes.Post_Staff_Internal_Notes.SUCCESS, response));
          // console.log('response.......',response)
          if (response && response.message){
            showSuccessMessage(response.message);            
            let searchObj = {
                sort_fields: '',
                sort_order:  '',
                contain_filters: { staffId: staffId, SearchText: null },
                pageNumber: 1,
            };      
            dispatch(getAllStaffInternalNotes(searchObj, staffId));            
          }
          else
            showSuccessMessage('Staff notes has been updated successfully');       
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getAllStaffInternalNotes = (searchObj, staffId) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);  
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.Get_Staff_Internal_Notes.REQUEST));
    fetch(`${GET_STAFF_INTERNAL_NOTES_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response.................', response)
        dispatch(actionCreator(userActionTypes.Get_Staff_Internal_Notes.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

export const deleteStaffInternalNote = (noteId, staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.Delete_Staff_Internal_Notes.REQUEST));
    let apiURL = `${DELETE_STAFF_INTERNAL_NOTES_API}?noteId=${noteId}`;
    fetch(`${apiURL}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          if (response && response.statusCode === 200){
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.Delete_Staff_Internal_Notes.SUCCESS, response));
            let searchObj = {
              sort_fields: '',
              sort_order:  '',
              contain_filters: { staffId: staffId, SearchText: null },
              pageNumber: 1,
          };      
          dispatch(getAllStaffInternalNotes(searchObj, staffId));
          }
          else{
            showSuccessMessage(response.message);
            dispatch(actionCreator(userActionTypes.Delete_Staff_Internal_Notes.SUCCESS, null));
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getStaffByTags = (searchObj) => {
  // console.log("getStaffByTags searchObj",searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_StaffByTags.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);

    fetch(`${GET_STAFFBYTAGS_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_StaffByTags.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_StaffByTags.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get_StaffByTags...', error);
      });

  };
};

export const getClientByTags = (searchObj) => {
  // console.log("getClientByTags searchObj",searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_ClientByTags.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);

    fetch(`${GET_CLIENTBYTAGS_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_ClientByTags.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_ClientByTags.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get_ClientByTags...', error);
      });

  };
};

export const getStaffTrainingTitleHoursForHIH = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_staffTrainingTitleHours.REQUEST));
    fetch(`${GET_STAFF_TRAINING_TITLE_HOURS_API}?staffId=${staffId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_staffTrainingTitleHours.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_staffTrainingTitleHours.SUCCESS, null));
        }
      })
      .catch((e) => {
        console.log('error get_staffTrainingTitleHours..', e);
      });
  };
};

export const saveStaffTrainingTitleHoursForHIH = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.post_staffTrainingTitleHours.REQUEST));
    fetch(`${POST_STAFF_TRAINING_TITLE_HOURS_API}`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staffTrainingTitleHours.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_staffTrainingTitleHours.SUCCESS, null));
        }
      })
      .catch((e) => {
        console.log('error post_staffPayrollRates..', e);
      });
  };
};


export const getUserRoles = (staffId, isViewAdminRolePermission) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_userRoles.REQUEST));
    fetch(`${GET_USERROLES_API}/${staffId}/${isViewAdminRolePermission}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {          
          dispatch(actionCreator(userActionTypes.get_userRoles.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_userRoles.SUCCESS, null));
        }
      })
      .catch((e) => {
        console.log('error get_userRoles..', e);
      });
  };
};


export const getAppointmentTypeList = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.get_appointmentType.REQUEST)); 

    fetch(`${GET_APPOINTMENTTYPELIST}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(userActionTypes.get_appointmentType.SUCCESS, response));
        } else {
          dispatch(actionCreator(userActionTypes.get_appointmentType.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get_appointmentType...', error);
      });

  };
};

export const resetUserEmail = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.post_resetUserEmail.REQUEST));
    fetch(`${POST_RESETUSEREMAIL}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_resetUserEmail.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(userActionTypes.post_resetUserEmail.SUCCESS, null));
        }
      })
      .catch((e) => {
        console.log('error post_resetUserEmail..', e);
      });
  };
};
export const checkEmailChangeValidationLinkIsValid = (token, checkBusinessName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(userActionTypes.post_checkEmailChangeValidation.REQUEST));
    fetch(`${POST_CHECKEMAILCHANGEVALIDATION}`, {
      method: 'POST',
      body: JSON.stringify(token),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': checkBusinessName,
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(userActionTypes.post_checkEmailChangeValidation.SUCCESS, response));
      })
      .catch((e) => {
        console.log('error post_ConfirmationUserEmail..', e);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/users/actions/UserActions.js